import React, { Component } from "react";
import { connect } from "react-redux";

import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer";

import "bootstrap/dist/css/bootstrap.min.css";
import "./profile.css";
import {
  getUserInfo,
  logOut,
  updateUser,
} from "../../../Redux/actions/userActions";
import PopUpModal from "../../../components/PopUpModal";
import { closeModal, showModal } from "../../../Redux/actions/modalActions";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.userData.email,
      phone_number: this.props.userData.phone_number,
      display_name: this.props.userData.display_name,
      first_name: this.props.userData.first_name,
      last_name: this.props.userData.last_name,
      delivery_address: this.props.userData.delivery_address,
      birthdate: this.props.userData.birthdate,
      gender: this.props.userData.gender,
      photo: this.props.userData.photo,
      isUpdated: false,
      isloggedIn: true,
      showModalLogOut: false,
      showModalEdit: false,
    };
  }

  handleCloseUpdate = () => {
    this.setState({
      isUpdated: false,
    });
  };

  handleCloseLogOut = () => {
    this.setState({
      showModalLogOut: false,
    });
  };

  handleLogout = () => {
    this.props.logOut();
  };

  handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      this.setState({
        photo: e.target.files[0],
      });
    }
  };
  removeSelectedImage = () => {
    this.setState({
      photo: this.props.userData.photo,
    });
  };

  handleUpdate = () => {
    const {
      email,
      phone_number,
      display_name,
      first_name,
      last_name,
      delivery_address,
      birthday,
      gender,
      photo,
    } = this.state;
    this.props.updateUser({
      token: this.props.token,
      email: email,
      phone_number: phone_number,
      display_name: display_name,
      first_name: first_name,
      last_name: last_name,
      delivery_address: delivery_address,
      birthday: birthday,
      gender: gender,
      photo: photo,
    });

    this.setState({
      isUpdated: true,
    });
    this.props.showModal();
  };
  componentDidMount() {
    document.title = "Lukopi - Profile";
  }
  render() {
    const { userData } = this.props;
    return (
      <div>
        <Navbar />
        <section className="container-fluid profile-section">
          <h2>User Profile</h2>

          <div className="profile-box">
            <div className="row profile-wrapper">
              <aside className="col profile-menu">
                <div className="profile-pict">
                  {this.state.photo ? (
                    <img
                      src={URL.createObjectURL(this.state.photo)}
                      //   style={styles.image}
                      alt="Thumb"
                    />
                  ) : (
                    <img src={`${userData.picture}`} alt="profile" />
                  )}
                </div>
                <h4 className="display-name">{userData.display_name}</h4>
                <p className="email-display">{userData.email}</p>
                <input
                  className="d-none"
                  type="file"
                  id="upload-button"
                  accept="image/*"
                  onChange={this.handleImage}
                />
                <label className="upload-button" htmlFor="upload-button">
                  Choose photo
                </label>
                {/* <button className="choose-pict">Choose photo</button> */}

                <button
                  className="remove-pict"
                  onClick={this.removeSelectedImage}
                >
                  Remove photo
                </button>
                <br />
                <button className="edit-pass">Edit Password</button>
                <p className="save-question">Do you want to save the change?</p>
                <button className="save-chg" onClick={this.handleUpdate}>
                  Save Change
                </button>
                {this.state.isUpdated === true ? (
                  <PopUpModal
                    body={"Your data has been updated"}
                    closeBtnOnly={true}
                    eventHandlerOne={this.handleCloseUpdate}
                  />
                ) : (
                  <></>
                )}

                <br />
                <button className="cancel">Cancel</button>
                <br />
                <button
                  className="log-out"
                  onClick={() => {
                    this.setState({
                      showModalLogOut: true,
                    });
                    this.props.showModal();
                  }}
                >
                  Log out
                </button>
                {this.state.showModalLogOut === true ? (
                  <PopUpModal
                    body={"Are you sure you want to logout?"}
                    eventHandlerSec={this.handleCloseLogOut}
                    eventHandlerPrim={this.handleLogout}
                  />
                ) : (
                  <></>
                )}
              </aside>
              <article className="col profile-details d-flex">
                <header className="head">
                  <h3>Contacts</h3>
                </header>

                <div className="form-wrapper">
                  <div className="form-left">
                    <form className="contact-form">
                      <label htmlFor="email">Email adress :</label>
                      <br />
                      <input
                        type="email"
                        id="email"
                        defaultValue={userData.email}
                        onChange={(e) =>
                          this.setState({
                            email: e.target.value,
                          })
                        }
                      />
                      <br />
                      <label htmlFor="d-address">Delivery Address :</label>
                      <br />
                      <textarea
                        type="text"
                        id="d-address"
                        rows="2"
                        cols="auto"
                        defaultValue={userData.delivery_address}
                        onChange={(e) =>
                          this.setState({
                            delivery_address: e.target.value,
                          })
                        }
                      />
                      <br />
                    </form>
                  </div>
                  <div className="form-right">
                    <form className="contact-form">
                      <label htmlFor="pNumber">Mobile Number:</label>
                      <br />
                      <input
                        type="tel"
                        id="pNumber"
                        defaultValue={userData.phone_number}
                        onChange={(e) =>
                          this.setState({
                            phone_number: e.target.value,
                          })
                        }
                      />
                    </form>
                  </div>
                </div>

                <h3>Details</h3>
                <div className="form-wrapper">
                  <div className="form-left">
                    <form className="details-form">
                      <label htmlFor="d-name">Display name:</label>
                      <br />
                      <input
                        type="text"
                        id="d-name"
                        defaultValue={userData.display_name}
                        onChange={(e) =>
                          this.setState({
                            display_name: e.target.value,
                          })
                        }
                      />
                      <br />
                      <label htmlFor="f-name">First name:</label>
                      <br />
                      <input
                        type="text"
                        id="f-name"
                        defaultValue={userData.first_name}
                        onChange={(e) =>
                          this.setState({
                            first_name: e.target.value,
                          })
                        }
                      />
                      <br />

                      <label htmlFor="l-name">Last name:</label>
                      <br />
                      <input
                        type="text"
                        id="l-name"
                        defaultValue={userData.last_name}
                        onChange={(e) =>
                          this.setState({
                            last_name: e.target.value,
                          })
                        }
                      />
                      <br />
                    </form>
                  </div>
                  <div className="form-right">
                    <form className="details-form">
                      <label htmlFor="b-day">Birthdate</label>
                      <br />
                      <input
                        type="date"
                        id="b-day"
                        defaultValue={new Date(
                          userData.birthdate
                        ).toLocaleString()}
                        onChange={(e) =>
                          this.setState({
                            birthdate: e.target.value,
                          })
                        }
                      />
                      <br />
                    </form>
                  </div>
                </div>

                <form className="gender-form">
                  <input
                    type="radio"
                    id="male"
                    name="gender"
                    defaultChecked={userData.gender === "Male"}
                    // defaultValue={this.state.gender}
                    value="Male"
                    onChange={(e) => {
                      this.setState({
                        gender: e.target.value,
                      });
                    }}
                  />
                  <label htmlFor="male">Male</label>
                  <input
                    type="radio"
                    id="female"
                    name="gender"
                    // defaultValue={this.state.gender}
                    defaultChecked={userData.gender === "Female"}
                    value="Female"
                    onChange={(e) => {
                      this.setState({
                        gender: e.target.value,
                      });
                    }}
                  />
                  <label htmlFor="female">Female</label>
                </form>
              </article>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userData: state.UserReducer.getUserResult,
    token: state.SignInReducer.postUserLoginToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => {
      dispatch(logOut());
    },
    updateUser: (data) => {
      dispatch(updateUser(data));
    },
    getInfo: () => {
      dispatch(getUserInfo());
    },
    showModal: () => {
      dispatch(showModal());
    },
    closeModal: () => {
      dispatch(closeModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
